// import { type RouteConfig, index, route } from '@react-router/dev/routes';
import { Route } from 'react-router';

import { SIDE_BAR_ACTION_ROUTE } from 'pages/disruption/supply-chain-snapshot/side-bar/utils';

/** routes.ts file for new disruption monitor routes
 * New Disruption Monitor Routes
 * 
 export default [
  route('disruptions', 'routes/disruption-monitor/items/items.route', [
    index('routes/disruption-monitor/items/items-index.route'),
    route('overview', 'pages/disruption/routes/disruptions.overview'),
    route('events', 'routes/disruption-monitor/events/events.route'),
    route('events/:eventId', 'routes/disruption-monitor/item-detail-events/item-detail-events.route'),
    route(':disruptionId', 'routes/disruption-monitor/item-detail/item-detail.route', [
      index('routes/disruption-monitor/item-detail/item-detail-index.route'),
      route('inventory', 'routes/disruption-monitor/item-detail-inventory/item-detail-inventory.route'),
      route('preference-cards', 'routes/disruption-monitor/item-detail-preference-cards/item-detail-preference-cards.route'),
      route('utilization', 'routes/disruption-monitor/item-detail-utilization/item-detail-utilization.route'),
      route('vendors', 'routes/disruption-monitor/item-detail-vendors/item-detail-vendors.route'),
      route('substitutes', 'routes/disruption-monitor/item-detail-substitutes/item-detail-substitutes.route', [
        route('request', 'routes/disruption-monitor/item-detail-substitute-request/item-detail-substitute-request.route'),
      ]),
    ]),
    route(
      ':disruptionId/loss-detection',
      'routes/disruption-monitor/item-detail-loss-detection/item-detail-loss-detection.route'
    ),
  ]),
] satisfies RouteConfig;
 
 * 
 */

export function getDisruptionMonitorRoutes(hasDisruptionsV2: boolean) {
  if (hasDisruptionsV2) {
    return (
      <Route path="disruptions" id="drm-root" lazy={() => import('routes/disruption-monitor/disruption-monitor.route')}>
        <Route index lazy={() => import('routes/disruption-monitor/items/items-index.route')} />
        <Route
          path="overview"
          id="drm-overview"
          lazy={() => import('routes/disruption-monitor/overview/overview.route')}
        />
        <Route
          path="events"
          lazy={() => import('routes/disruption-monitor/item-detail-events/item-detail-events.route')}
        />
        {/* <Route
          path="events/:eventId"
          id="drm-event-details"
          lazy={() => import('pages/disruption/routes/disruptions.events.$eventId')}
        /> */}
        <Route
          path=":itemId"
          id="drm-item"
          lazy={() => import('routes/disruption-monitor/item-detail/item-detail.route')}
        >
          <Route
            index
            id="drm-item-params"
            lazy={() => import('routes/disruption-monitor/item-detail/item-detail-index.route')}
          />
          <Route
            path="inventory"
            lazy={() => import('routes/disruption-monitor/item-detail-inventory/item-detail-inventory.route')}
          />
          <Route
            path="preference-cards"
            lazy={() =>
              import('routes/disruption-monitor/item-detail-preference-cards/item-detail-preference-cards.route')
            }
          />
          <Route
            path="utilization"
            lazy={() => import('routes/disruption-monitor/item-detail-utilization/item-detail-utilization.route')}
          />
          <Route
            path="vendors"
            lazy={() => import('routes/disruption-monitor/item-detail-vendors/item-detail-vendors.route')}
          />
          <Route
            path="substitutes"
            lazy={() => import('routes/disruption-monitor/item-detail-substitutes/item-detail-substitutes.route')}
          >
            <Route
              path="request"
              lazy={() =>
                import('routes/disruption-monitor/item-detail-substitutes/item-detail-substitute-request.route')
              }
            />
          </Route>
          <Route
            path="events"
            lazy={() => import('routes/disruption-monitor/item-detail-events/item-detail-events.route')}
          />

          {/* <Route
            path={SIDE_BAR_ACTION_ROUTE}
            lazy={() => import('pages/disruption/supply-chain-snapshot/side-bar/side-bar-action')}
          /> */}
        </Route>
        <Route
          id="loss-detection"
          path=":itemId/loss-detection"
          lazy={() => import('routes/disruption-monitor/item-detail-loss-detection/item-detail-loss-detection.route')}
        />
        <Route path="resources">
          <Route path="permissions" lazy={() => import('routes/disruption-monitor/resources/permissions')} />
          <Route path="disruption-types" lazy={() => import('routes/disruption-monitor/resources/disruption-types')} />
        </Route>
      </Route>
    );
  }

  /* Old Disruption Monitor Routes */

  return (
    <>
      <Route path="disruptions" id="drm-root" lazy={() => import('pages/disruption/routes/disruptions')}>
        <Route index lazy={() => import('pages/disruption/routes/disruptions.index')} />
        <Route path="overview" id="drm-overview" lazy={() => import('pages/disruption/routes/disruptions.overview')} />
        <Route path="events" lazy={() => import('pages/disruption/routes/disruptions.events')} />
        <Route
          path="events/:eventId"
          id="drm-event-details"
          lazy={() => import('pages/disruption/routes/disruptions.events.$eventId')}
        />
        <Route
          path=":disruptionId"
          id="drm-item"
          lazy={() => import('pages/disruption/routes/disruptions.$disruptionId')}
        >
          <Route
            index
            id="drm-item-params"
            lazy={() => import('pages/disruption/routes/disruptions.$disruptionId.index')}
          />
          <Route path="inventory" lazy={() => import('pages/disruption/routes/disruptions.$disruptionId.inventory')} />
          <Route
            path="preference-cards"
            lazy={() => import('pages/disruption/routes/disruptions.$disruptionId.preference-cards')}
          />
          <Route
            path="utilization"
            lazy={() => import('pages/disruption/routes/disruptions.$disruptionId.utilization')}
          />
          <Route path="vendors" lazy={() => import('pages/disruption/routes/disruptions.$disruptionId.vendors')} />
          <Route
            path="substitutes"
            lazy={() => import('pages/disruption/routes/disruptions.$disruptionId.substitutes')}
          >
            <Route
              path="request"
              lazy={() => import('pages/disruption/routes/disruptions.$disruptionId.substitutes.request')}
            />
          </Route>
          <Route path="events" lazy={() => import('pages/disruption/routes/disruptions.$disruptionId.events')} />

          <Route
            path={SIDE_BAR_ACTION_ROUTE}
            lazy={() => import('pages/disruption/supply-chain-snapshot/side-bar/side-bar-action')}
          />
        </Route>
        <Route
          id="loss-detection"
          path=":disruptionId/loss-detection"
          lazy={() => import('pages/disruption/routes/disruptions.$disruptionId.loss-detection')}
        />
      </Route>
    </>
  );
}
